import { render } from "./download-reports.vue?vue&type=template&id=ebb0eb1c&scoped=true&ts=true"
import script from "./download-reports.vue?vue&type=script&lang=ts"
export * from "./download-reports.vue?vue&type=script&lang=ts"

import "./download-reports.vue?vue&type=style&index=0&id=ebb0eb1c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb0eb1c"]])

export default __exports__